import { AxiosError } from 'axios';
import { Path } from 'react-hook-form';

import {
  ErrorResponse,
  ErrorResponseFE,
  InputId,
} from 'components/actionModal/models';
import {
  CorporateAccountFormValues,
  ServerErrorPayload,
} from 'modules/accounts/models';

export const formatServerError = (
  errorMessage: AxiosError<ServerErrorPayload> | null,
  errorResponse: Partial<ErrorResponse>
) => {
  if (!errorMessage?.response?.data) return undefined;

  const serverMessage = errorMessage.response.data.payload?.message;

  if (serverMessage === errorResponse.GROUP_NAME_TAKEN) {
    return {
      input: InputId.CompanyNameInputId as Path<CorporateAccountFormValues>,
      message: ErrorResponseFE.GROUP_NAME_TAKEN,
    };
  }
};
